export default __webpack_public_path__ + "static/media/glass_graphic.453d0fdf.JPG";